exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ba-common-carbon-tooltip-popup__container{user-select:none;position:absolute;z-index:999999;max-width:160px;text-align:center;min-height:20px;pointer-events:none}.ba-common-carbon-tooltip-popup__container .ba-common-carbon-tooltip-popup__box{min-width:100px;max-width:160px;position:absolute;pointer-events:none;height:inherit}", ""]);

// exports
exports.locals = {
	"tooltipPopupClassName": "\"ba-common-carbon-tooltip-popup\""
};